/* eslint-disable camelcase */
/** Maps the key used in segmemt for inputs to their property name in our code
 * Having an explicit mapping allows us to decouple those names
 */
export const segmentKeysToInputKeys = {
  property_value: 'propertyValue',
  mortgage_amount: 'mortgageAmount',
  repayment_period: 'repaymentPeriod',
  rate_type: 'rateType',
  payment_type: 'paymentType',
  initial_period: 'initialPeriod',
  purchase_stage: 'purchaseStage',
}
